import { render, staticRenderFns } from "./sendTeac.vue?vue&type=template&id=026900de&scoped=true&"
import script from "./sendTeac.vue?vue&type=script&lang=js&"
export * from "./sendTeac.vue?vue&type=script&lang=js&"
import style0 from "./sendTeac.vue?vue&type=style&index=0&id=026900de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026900de",
  null
  
)

export default component.exports